import home from './home';

const pages = {
  home
}

export default pages;
